import { IAction, IReducer } from '@se/se.ui.advanced';
import { EcgState } from './ecgstate';
import {
    ARRANGEMENT,
    BASELINE,
    CALIPER_MODE,
    CULTURE,
    CUSTOM_COMMAND,
    DETAILS_VISIBLE,
    FIDUCIAL_POINTS_VISIBLE,
    FIT,
    FORMAT,
    FULL_STATE,
    GUIDED_COMPARISON,
    HORIZONTAL_STUDY_SPACING,
    PAPER_OPACITY,
    PAPER_RATE,
    PRINT_AS_DISPLAYED,
    STUDY_SPACING,
    SUMMARY_VISIBLE,
    TIME_ALIGNMENT,
    TOOLBAR_VISIBLE,
    TRACE_SPACING,
    VISUAL_COMPARISON,
    ZOOM_FACTOR,
} from '../redux/actions';

export class EcgReducer implements IReducer<EcgState> {
    buildState(state: EcgState, action: IAction): EcgState {
        switch (action.type) {
            case TOOLBAR_VISIBLE:
                let viewerState = Object.assign({}, state.viewerState, { toolbarVisible: action.payload });
                return Object.assign({}, state, { viewerState: viewerState });

            case ARRANGEMENT: {
                let chartState = Object.assign({}, state.chartState, { arrangement: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case FORMAT: {
                let chartState = Object.assign({}, state.chartState, { format: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case TIME_ALIGNMENT: {
                let chartState = Object.assign({}, state.chartState, { timeAlignment: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case PAPER_RATE: {
                let chartState = Object.assign({}, state.chartState, { paperRate: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case PAPER_OPACITY: {
                let chartState = Object.assign({}, state.chartState, { paperOpacity: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case BASELINE: {
                let chartState = Object.assign({}, state.chartState, { isFitBaseline: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case TRACE_SPACING: {
                let chartState = Object.assign({}, state.chartState, { traceSpacing: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case STUDY_SPACING: {
                let multiViewerState = Object.assign({}, state.multiViewerState, { studySpacing: action.payload });
                return Object.assign({}, state, { multiViewerState: multiViewerState });
            }
            case HORIZONTAL_STUDY_SPACING: {
                let multiViewerState = Object.assign({}, state.multiViewerState, {
                    horizontalStudySpacing: action.payload,
                });
                return Object.assign({}, state, { multiViewerState: multiViewerState });
            }
            case GUIDED_COMPARISON: {
                let chartState = Object.assign({}, state.chartState, {
                    traceSpacing: action.payload.traceSpacing,
                    guidedComparison: action.payload.guidedComparison,
                });
                let multiViewerState = Object.assign({}, state.multiViewerState, {
                    studySpacing: action.payload.studySpacing,
                    horizontalStudySpacing: action.payload.horizontalStudySpacing,
                });
                return Object.assign({}, state, { chartState: chartState }, { multiViewerState: multiViewerState });
            }
            case CALIPER_MODE: {
                let chartState = Object.assign({}, state.chartState, { caliperMode: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case FIDUCIAL_POINTS_VISIBLE: {
                let chartState = Object.assign({}, state.chartState, { fiducialPointsVisible: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case PRINT_AS_DISPLAYED: {
                let chartState = Object.assign({}, state.chartState, { printAsDisplayed: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case ZOOM_FACTOR: {
                let chartState = Object.assign({}, state.chartState, { zoomFactor: action.payload });
                return Object.assign({}, state, { chartState: chartState });
            }
            case CULTURE: {
                return Object.assign({}, state, { culture: action.payload });
            }
            case DETAILS_VISIBLE: {
                let detailsState = Object.assign({}, state.detailsState, { visible: action.payload });
                return Object.assign({}, state, { detailsState: detailsState });
            }
            case SUMMARY_VISIBLE: {
                let summaryState = Object.assign({}, state.detailsState.summaryState, { visible: action.payload });
                let detailsState = Object.assign({}, state.detailsState, { summaryState: summaryState });
                return Object.assign({}, state, { detailsState: detailsState });
            }
            case CUSTOM_COMMAND: {
                let toolbarState = Object.assign({}, state.toolbarState, { customCommandState: action.payload });
                return Object.assign({}, state, { toolbarState: toolbarState });
            }
            case VISUAL_COMPARISON: {
                return Object.assign({}, state, { visualComparison: action.payload });
            }

            case FULL_STATE:
                return Object.assign({}, state, action.payload);

            case FIT:
            default:
                return state;
        }
    }
}
